var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rx-button-select"},[(_vm.canClear)?_c('div',{staticClass:"clear-button",on:{"click":_vm.clear}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(name,value){return _c('div',{staticClass:"select-button",class:_vm.inputValue === value ? 'selected' : '',domProps:{"innerHTML":_vm._s(name)},on:{"click":function($event){return _vm.itemClick(value)}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14785b14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/inputs/RxButtonSelect.vue
// module id = 88
// module chunks = 0 1